import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import * as Icons from '../../common/icons/scrumMethodology';
// import { methodologyData } from '../../common';

const ScrumMethodology = () => {
    const [methodologyData, setData] = useState({});

    const getAllMethodologyDataData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/methodologyData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        getAllMethodologyDataData();
    }, [])

    return (
        <section className='ScrumMethodology'>
            <Container className='page-warper'>
                <Row className='page-heading'>
                    <Col lg="7" md="7" className="align-self-start">
                        <h4>{methodologyData?.title}</h4>
                        <p>{methodologyData?.paragraph}</p>
                    </Col>
                </Row>
                <div className='custom-card d-flex align-items-center justify-content-between gap-4'>
                    {methodologyData?.methodologies?.map((methodology, index) => {
                        const Icon = Icons[methodology?.icon] || null;
                        return (
                            <Card key={index} className='p-4 mt-4'>
                                <CardHeader className='border-0'>
                                    {Icon && <Icon />}
                                </CardHeader>
                                <CardBody>
                                    <p>{methodology?.paragraph}</p>
                                </CardBody>
                            </Card>
                        )
                    })}
                </div>
            </Container>
        </section>
    );
}

export default ScrumMethodology;
